import React from "react";
import { LocalStorageInfo } from "./LocalStorageInfo";
import { AppContextUtil } from "./AppContextUtil";
import { NotificationDto } from "services/apis/types/notification/NotificationDto";

type AppContextWrapper = {
  appContext: AppContext;
  setAppContext: (newAppContext: AppContext) => unknown;
};

export type AppContext = {
  localStorageInfo: LocalStorageInfo;
  notifications?: NotificationDto[];
  initialized: boolean;
  showSessionExpiredError: boolean;
  previousUrl: string,
  isLoggedOut: boolean;
  theme: 'light' | 'dark'; // Add theme property
  changeTheme: (newTheme: 'light' | 'dark') => void; // Add changeTheme function
  dropdownDisabled: boolean;
  setDropdownDisabled: (disabled: boolean) => void;
  showFeedbackPopUp: boolean;
};

export function GetAppContext(): AppContext {
  const info: LocalStorageInfo = AppContextUtil.getFromLocalStorage();

  return {
    localStorageInfo: info,
    initialized: false,
    showSessionExpiredError: false,
    previousUrl: '',
    isLoggedOut: false,
    theme: 'light', // Default theme
    changeTheme: () => {}, // Default no-op function
    dropdownDisabled: false,
    setDropdownDisabled: () => {}, // Add default
    showFeedbackPopUp: true
  };
}

export const AppContext = React.createContext<AppContextWrapper>({
  appContext: GetAppContext(),
  setAppContext: () => {}
});
